import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-4 divide-y lg:divide-y-0 lg:divide-x px-4" }
const _hoisted_2 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_4 = { class: "col-span-1" }
const _hoisted_5 = {
  key: 0,
  class: "col-span-1"
}
const _hoisted_6 = { class: "col-span-1" }
const _hoisted_7 = {
  key: 1,
  class: "col-span-1"
}
const _hoisted_8 = {
  key: 2,
  class: "col-span-1"
}
const _hoisted_9 = { class: "col-span-3 lg:col-span-1 pt-4 lg:pl-4 lg:pt-0" }
const _hoisted_10 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_11 = { class: "col-span-1" }
const _hoisted_12 = { class: "font-medium" }
const _hoisted_13 = { class: "col-span-1" }
const _hoisted_14 = { class: "font-medium" }
const _hoisted_15 = { class: "col-span-1" }
const _hoisted_16 = { class: "col-span-1" }
const _hoisted_17 = { class: "col-span-1" }
const _hoisted_18 = { class: "col-span-1" }
const _hoisted_19 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_20 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_21 = { class: "grid grid-cols-2 gap-4 pt-4 lg:pl-4 lg:pt-0" }
const _hoisted_22 = { class: "col-span-1" }
const _hoisted_23 = { class: "col-span-1" }
const _hoisted_24 = { class: "col-span-1" }
const _hoisted_25 = { class: "col-span-1" }
const _hoisted_26 = { class: "col-span-1" }
const _hoisted_27 = { class: "col-span-1" }
const _hoisted_28 = { class: "col-span-1" }
const _hoisted_29 = {
  key: 0,
  class: "w-full mt-6"
}

import { // store
		localesStore
	} from '@/store/locales'

	import { 
		store as _userStore
	} from '@/store/user'

	import { // vue
		computed
	} from 'vue'

	
	const __default__ = { name: 'JobAdditionalDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		job: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()
	const userStore = _userStore()

	const isWeddingCategory = computed(() => {
		return props?.job?.fieldData?.category?.toLowerCase()?.includes('wedding') 
	})

	const isWeddingType = computed(() => {
		return props?.job?.fieldData?.type?.toLowerCase()?.includes('wedding')
	})

	const rehearsalCountAdults = computed(() => {
		if(props?.job?.fieldData?.rehearsal_adults_count > -1) return props?.job?.fieldData?.rehearsal_adults_count
		else if(props?.job?.fieldData?.rehearsal_adults_count_party > -1) return props?.job?.fieldData?.rehearsal_adults_count_party
		else return ''
	}
	)
	const rehearsalCountKids = computed(() => {
		if(props?.job?.fieldData?.rehearsal_kids_count > -1) return props?.job?.fieldData?.rehearsal_kids_count
		else if(props?.job?.fieldData?.rehearsal_kids_count_party > -1) return props?.job?.fieldData?.rehearsal_kids_count_party
		else return ''
	})

return (_ctx: any,_cache: any) => {
  const _component_data_display = _resolveComponent("data-display")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: isWeddingType.value || isWeddingCategory.value ? _unref(store).getLabel('238') : _unref(store).getLabel('628'),
            value: __props.job?.fieldData?.name_groom_display || '—'
          }, null, 8, ["loading", "label", "value"])
        ]),
        (isWeddingType.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_data_display, {
                loading: __props.loading,
                label: _unref(store).getLabel('240'),
                value: __props.job?.fieldData?.groom_side_count || '—'
              }, null, 8, ["loading", "label", "value"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: isWeddingType.value || isWeddingCategory.value ? _unref(store).getLabel('237') : _unref(store).getLabel('629'),
            value: __props.job?.fieldData?.name_bride_display || '—'
          }, null, 8, ["loading", "label", "value"])
        ]),
        (isWeddingType.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_data_display, {
                loading: __props.loading,
                label: _unref(store).getLabel('241'),
                value: __props.job?.fieldData?.bride_side_count || '—'
              }, null, 8, ["loading", "label", "value"])
            ]))
          : _createCommentVNode("", true),
        (isWeddingType.value || isWeddingCategory.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_data_display, {
                loading: __props.loading,
                label: _unref(store).getLabel('239'),
                value: __props.job?.fieldData?.married_name_display || '—'
              }, null, 8, ["loading", "label", "value"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_data_display, null, {
            custom: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !__props.job?.fieldData?.rehearsal_checkbox}])
              }, [
                (__props.job?.fieldData?.rehearsal_checkbox)
                  ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                      key: 0,
                      class: "h-5 w-5"
                    }))
                  : (_openBlock(), _createBlock(_component_MinusIconMini, {
                      key: 1,
                      class: "h-5 w-5"
                    })),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(store).getLabel('244')), 1)
              ], 2)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_data_display, null, {
            custom: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !__props.job?.fieldData?.demo_checkbox}])
              }, [
                (__props.job?.fieldData?.demo_checkbox)
                  ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                      key: 0,
                      class: "h-5 w-5"
                    }))
                  : (_openBlock(), _createBlock(_component_MinusIconMini, {
                      key: 1,
                      class: "h-5 w-5"
                    })),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(store).getLabel('319')), 1)
              ], 2)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: _unref(store).getLabel('242'),
            value: __props.job?.fieldData?.rehearsal_checkbox ? __props.job?.fieldData?.zctRehearsalDateFormatted || '—' : '—'
          }, null, 8, ["loading", "label", "value"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: _unref(store).getLabel('245'),
            value: __props.job?.fieldData?.rehearsal_checkbox ? rehearsalCountAdults.value : '—'
          }, null, 8, ["loading", "label", "value"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: _unref(store).getLabel('243'),
            value: __props.job?.fieldData?.rehearsal_checkbox ? _ctx.$filters.hour24Time(__props.job?.fieldData?.time_rehearsal) || '—' : '—'
          }, null, 8, ["loading", "label", "value"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: _unref(store).getLabel('246'),
            value: __props.job?.fieldData?.rehearsal_checkbox ? rehearsalCountKids.value : '—'
          }, null, 8, ["loading", "label", "value"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_data_display, {
              loading: __props.loading,
              label: _unref(store).getLabel('196'),
              value: __props.job?.fieldData?.status_display || '—'
            }, null, 8, ["loading", "label", "value"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_data_display, {
              loading: __props.loading,
              label: _unref(store).getLabel('233'),
              value: _ctx.$filters.hour24Time(__props.job?.fieldData?.time_arrival) || '—'
            }, null, 8, ["loading", "label", "value"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_data_display, {
              loading: __props.loading,
              label: _unref(store).getLabel('143'),
              value: __props.job?.fieldData?.zctDateFormatted || '—'
            }, null, 8, ["loading", "label", "value"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_data_display, {
              loading: __props.loading,
              label: _unref(store).getLabel('234'),
              value: _ctx.$filters.hour24Time(__props.job?.fieldData?.time_standby) || '—'
            }, null, 8, ["loading", "label", "value"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_data_display, {
              loading: __props.loading,
              label: _unref(store).getLabel('144'),
              value: _ctx.$filters.hour24Time(__props.job?.fieldData?.time_start) || '—'
            }, null, 8, ["loading", "label", "value"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_data_display, {
              loading: __props.loading,
              label: _unref(store).getLabel('499'),
              value: _ctx.$filters.hour24Time(__props.job?.fieldData?.time_final) || '—'
            }, null, 8, ["loading", "label", "value"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_data_display, {
              loading: __props.loading,
              label: isWeddingType.value || isWeddingCategory.value ? _unref(store).getLabel('140') : _unref(store).getLabel('636'),
              value: __props.job?.fieldData?.['job__CONTACTS__plannerID::name_display']?.trim() || '—'
            }, null, 8, ["loading", "label", "value"])
          ])
        ])
      ])
    ]),
    (_unref(userStore).getContactType != 'Staff')
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: _unref(store).getLabel('205'),
            value: __props.job?.fieldData?.['job__JOBS_INFO__jobID::notes_jobs_client_display'] || '—'
          }, null, 8, ["loading", "label", "value"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})